import { useCallback } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const CONTACTS_PER_PAGE = 10;

const useAccountContacts = (accountId) => {
	const fetchFn = useCallback(
		async (page) => {
			if (!accountId) return { data: [], totalCount: 0 };
			const response = await salesforceAccountsService.getContacts(
				accountId,
				page,
				CONTACTS_PER_PAGE
			);
			return {
				data: response?.contacts || [],
				totalCount: response?.total || 0,
			};
		},
		[accountId]
	);

	const { data, totalCount, loading, loadingMore, error, hasMore, loadMore } =
		useInfiniteResource({ fetchFn });

	return {
		contacts: data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
	};
};

export default useAccountContacts;
